import React, { useState, useMemo } from 'react';

import { ThemeProvider } from '@mui/material/styles';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

import { LOCALSTORAGE } from 'config';
import { ColorModeContext } from 'contexts';
import generateTheme from 'theme';

export const muiCache = createCache({
    key: 'mui',
    prepend: true,
});

const ThemeInjector: React.FunctionComponent<
    React.PropsWithChildren<unknown>
> = ({ children }) => {
    const initialModeDark =
        localStorage.getItem(LOCALSTORAGE.THEMEMODE ?? 'theme-mode') === 'dark';
    const [mode, setMode] = useState<'light' | 'dark'>(
        initialModeDark ? 'dark' : 'light',
    );

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => {
                    const nextMode = prevMode === 'light' ? 'dark' : 'light';
                    localStorage.setItem(LOCALSTORAGE.THEMEMODE, nextMode);
                    return nextMode;
                });
            },
        }),
        [],
    );

    const theme = useMemo(() => generateTheme(mode), [mode]);

    return (
        <ColorModeContext.Provider value={colorMode}>
            <CacheProvider value={muiCache}>
                <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </CacheProvider>
        </ColorModeContext.Provider>
    );
};

export default ThemeInjector;
